import React from "react";
import styled from "styled-components";
import { Toast } from "antd-mobile";
import useGlobal from "../../../hooks/useGlobal";
import useWallet from "../../../hooks/Wallet/useWallet";
import { handlerWalletTxError } from "../../../utils/utils";
import { useIntl, FormattedMessage } from "react-intl";
import useContract from "../../../hooks/useContract";

export default function SyncBtn() {
  const {
    stepNum,
    userInfo,
    checkSum,
    getTxOptions,
    addTxHashList,
  } = useGlobal();
  const { toLogin } = useWallet();
  const { getRunContract } = useContract();
  const intl = useIntl();
  const startSync = async () => {
    if (!userInfo) {
      toLogin();
      return;
    }
    if (userInfo.steps === undefined || !checkSum) {
      Toast.show({
        content: intl.formatMessage({
          id: "common.syncing_from_chain",
          defaultMessage: "正在同步链上数据...",
        }),
        duration: 3000,
      });
      return;
    }
    if (!userInfo.equips.find((e) => !!e)) {
      Toast.show({
        content: intl.formatMessage({
          id: "common.no_mounted_equip",
          defaultMessage: "您未穿戴任何装备，无需同步",
        }),
        duration: 3000,
      });
      return;
    }
    if (stepNum === userInfo.steps) {
      Toast.show({
        content: intl.formatMessage({
          id: "pages.home.synced",
          defaultMessage: "已同步",
        }),
        duration: 3000,
      });
      return;
    }
    Toast.show({
      icon: "loading",
      duration: 0,
      content: intl.formatMessage({
        id: "pages.home.syncing",
        defaultMessage: "同步中...",
      }),
    });
    try {
      console.log("checkSum", checkSum);
      const runContract = await getRunContract();
      let gaslimit = await runContract.estimateGas.updateSteps(checkSum);
      const opts = await getTxOptions(gaslimit)
      const tx = await runContract.updateSteps(checkSum, opts);
      Toast.show({
        content: intl.formatMessage({
          id: "common.waiting_tx",
        }),
        icon: "success",
      });
      // await tx.wait(2)
      await addTxHashList(
        "sync",
        tx,
        {
          checkSum,
        },
        {
          success: "pages.home.sync_success",
          fail: "pages.home.sync_fail",
        }
      );

      // loading.close();
      // Toast.show({
      //   content: intl.formatMessage({
      //     id: "pages.home.sync_success",
      //     defaultMessage: "同步成功",
      //   }),
      //   icon: "success",
      // });
    } catch (e) {
      const reason = handlerWalletTxError(e, intl);
      Toast.show({
        content:
          intl.formatMessage({
            id: "pages.home.sync_fail",
            defaultMessage: "同步失败",
          }) +
          ": " +
          reason,
        icon: "fail",
      });
    }
  };
  return (
    <Wrapper onClick={startSync}>
      <Inner>
        <div className="text_sync">
          <img src="/image/lightning.png" alt="lightning" width={"2.0rem"} />
          {intl.formatMessage({
            id: "pages.home.sync",
            defaultMessage: "同步",
          })}
        </div>
        <p className="text_synced">
          {intl.formatMessage({
            id: "pages.home.synced",
            defaultMessage: "已同步",
          })}{" "}
          &nbsp;
          <span className="text_sync_num">
            <FormattedMessage
              id="components.nav.step"
              values={{
                step:
                  userInfo && userInfo.steps !== undefined
                    ? userInfo.steps
                    : "--",
              }}
            />
          </span>
        </p>
      </Inner>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  text-align: center;
  margin-top: 2.5rem;
`;

const Inner = styled.div`
  display: inline-block;
  width: 13.3rem;
  text-align: center;
  padding: 1.0rem 0;
  background: #fc9043;
  border: .05rem solid #000000;
  box-shadow: inset -2px -2px .0rem #d63c2a, inset 1px 1px .0rem #ffe6d5;
  border-radius: 1.2rem;
  .text_sync {
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 1.6rem;
    color: #ffffff;
    text-shadow: .15rem 1px .0rem #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      margin-right: .6rem;
    }
  }
  .text_synced {
    font-style: normal;
    font-weight: 400;
    font-size: 1.3rem;
    line-height: 1.3rem;

    color: #000000;
    margin-top: .6rem;
  }
  .text_sync_num {
    font-weight: 900;
  }
`;
